import styled from 'styled-components'
import Container from './layout/Container'
import Stack from './layout/Stack'
import SectionHeading from './SectionHeading'
import TinyCard, { StyledTinyCard } from './TinyCard'

function SessionChunks( { chunks, sessionId } ) {
  if ( !chunks?.length ) {
    return null
  }
  
  return (
    <Container>
      <Stack
        $top={ 4 }
        $between={ 1.5 }
        $bottom={ 5 }
        $responsive
      >
        <SectionHeading>
          Explore this session
        </SectionHeading>
        <StyledGrid>
          { chunks.map( ( chunk, i ) => (
            <TinyCard
              key={ chunk.id }
              href={ `/course/chunks/${ chunk.slug }?sessionId=${ sessionId }` }
              type={ chunk.chunkType.length > 0 && `${ i + 1 }. ${ chunk.chunkType[ 0 ].title }` }
              title={ chunk.title }
            />
          ) ) }
        </StyledGrid>
      </Stack>
    </Container>
  )
}

const StyledGrid = styled.div`
  display: grid;
  margin: calc( var( --grid-gutter ) / -2 );

  > * {
    margin: calc( var( --grid-gutter ) / 2 );
  }

  @media ( min-width: 650px ) {
    grid-template-columns: repeat( 3, 1fr );
  }

  ${ StyledTinyCard } {
    a {
      background: ${ p => p.theme.colors.orangeShade };
      box-shadow: none;

      p:first-child {
        border-bottom-color: ${ p => p.theme.colors.orange };
      }

      &:hover {
        background: ${ p => p.theme.colors.black };
      }
    }
  }
`

export default SessionChunks
